<style scoped lang="scss">
iframe {
  border: none;
  width: 100%;
  vertical-align: bottom;
}

::-webkit-scrollbar {
  display: none;
}

/* fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.sidebar::-webkit-scrollbar {
  display: none;
}

.sidebar {
  border-radius: 0px 30px 0px 0px;
  background: #303a50;

  .el-menu {
    padding-top: 30px;
    box-sizing: border-box;
    border: none;
  }

  .my-menu:not(.el-menu--collapse) {
    width: v-bind(dynamicMenuWidth + 'px');
  }
}
</style>
<style lang="scss">
.sidebar {

  /*隐藏文字*/
  .el-menu--collapse .el-submenu__title span {
    display: none;
  }

  .el-menu--collapse .el-menu-item span {
    display: none;
  }

  /*隐藏 > */
  .el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
    display: none;
  }
}
</style>
<template>
  <div class="page_content">
    <div class="index_content" style="width: 100%;">
      <div style="display:flex;justify-content:space-between;">
        <div v-show="!store.state.is_monitor_full" class="sidebar" ref="sidebar" :style="{ height: side_height, width: store.state.is_sidebar_open ? dynamicMenuWidth + 'px' : '64px' }" style="overflow: auto;overflow-x:hidden;flex-shrink:0;">
          <div style="display: flex;width: 100%;justify-content: space-between;align-items: flex-end;padding-top: 21px;">
            <img v-if="store.state.is_sidebar_open" style="position: absolute;z-index: 0;width:129px;height: 26px;margin-left: 18px;" src="../../assets/img/common/logo_side.png" />
            <div style="flex: 1;"></div>
            <div style="background: #303a50;height: 26px;z-index: 1;cursor: pointer;">
              <img @click="toggleSidebar()" style="width:20px;height: 20px;margin-right: 16px ;" :style="{ 'margin-right': store.state.is_sidebar_open ? '16px' : '22px', transform: store.state.is_sidebar_open ? 'rotate(0deg)' : 'rotate(180deg)' }" src="../../assets/img/sidebar/expand.png" />
            </div>
          </div>
          <el-menu class="my-menu" background-color="#303A50" text-color="#FFFFFF" active-text-color="#419FFF" :router="true" :default-active="$route.path" :collapse="!store.state.is_sidebar_open">
            <dynamic_nav :isFirst="true" :menuList="store.state.menus" />
          </el-menu>
        </div>
        <div style="flex:1;">
          <div v-show="!store.state.is_monitor_full" ref="header">
            <yi_header></yi_header>
          </div>
          <div v-show="!store.state.is_monitor_full" class="indexTabs" style="padding: 12px 24px 0px 24px;box-sizing: border-box;height: 68px;" :style="{ width: content_width }" ref="router_tabs">
            <el-tabs v-model="current_path" type="card" :closable="routerTabs.length > 1" @tab-remove="removeTab" @tab-click="clickTab">
              <el-tab-pane v-for="(tab, index) in routerTabs" :key="tab.path" :label="$t(tab.name)" :name="tab.path"></el-tab-pane>
            </el-tabs>
          </div>
          <div :style="{ height: height }" style="width: 100%;overflow: auto;position:relative">
            <!-- {{ routers }}{{ current_path }}{{ current_path }} -->
            <div v-show="current_path.indexOf('/web/common/biframe') == -1" style="box-sizing:border-box;position:absolute; width:100%;height:100%">
              <transition name="fade" mode="out-in">
                <keep-alive :include="routerComponentNames">
                  <router-view></router-view>
                </keep-alive>
              </transition>
            </div>

            <div v-if="(tab.link != null) && (tab.link.indexOf('/web/common/biframe') != -1)" v-for="tab in routers" style="height: 100%;width: 100%;padding: 0px 20px 0px 20px;box-sizing: border-box;" :style="{ 'height': current_path == tab.path ? '100%' : '0px' }">
              <iframe v-show="current_path == tab.path" style="width: 100%;height: 100%;padding-bottom: 20px;" :src="makeUrl(tab.link)">
                <p>您的浏览器不支持 iframe 标签,请从列表中下载预览</p>
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import yi_header from "@@/components/header/yi_header";

export default {
  name: "index",
  components: {
    yi_header,
  },
  watch: {
    $route: {
      handler(to, from) {
        this.current_path = to.path;
      },
      immediate: true,
    },
  },
  data() {
    return {
      sidebar_arr: [],
      side_height: "0px",
      height: "0px",
      current_path: null,
      content_width: "0px",
    };
  },
  created() {
    this.utils.event_hub.$on("RESIZE_INDEX", this.resizeWindow);
    this.utils.event_hub.$on("TOGGLE_TABBAR", this.toggleTabbar);
  },
  mounted() {
    /*假设header还没加载好，在create无法调用，所以在mounted检测*/
    // if (!this.utils.isAdminLogin()) {
    // 	this.utils.event_hub.$emit('403', null);

    // }
    this.resizeWindow();
    window.addEventListener("resize", () => {
      this.resizeWindow();
    });

    // var elementResizeDetectorMaker = require("element-resize-detector")
    // var erd = elementResizeDetectorMaker();
    // erd.listenTo(this.$refs.sidebar, (element) => {
    // 	setTimeout(()=>{
    // 		this.resizeWindow();
    // 	},100)
    // });
  },
  destroyed() {
    window.removeEventListener("resize", null);
  },
  computed: {

    routers() {
      return this.store.state.router_tabs.map((item) => {
        return item;
      });
    },
    routerComponentNames() {
      return this.store.state.router_tabs.map((item) => {
        return item.componentName;
      });
    },
    routerTabs() {
      return this.store.state.router_tabs;
    },
    // 计算菜单动态宽度
    dynamicMenuWidth() {
      if (!this.store.state.menus || !this.store.state.is_sidebar_open) {
        return 200; // 最小宽度
      }

      // 计算所有菜单项的最大宽度
      const maxWidth = this.calculateMenuWidth(this.store.state.menus);
      return Math.max(200, maxWidth + 60); // 200px最小宽度，额外60px用于图标和边距
    },
  },
  methods: {
    // 计算菜单宽度的方法
    calculateMenuWidth(menuList) {
      let maxWidth = 0;

      if (!menuList || !Array.isArray(menuList)) {
        return maxWidth;
      }

      menuList.forEach(item => {
        if (item.visible !== false) {
          // 获取翻译后的文本
          const text = this.$t(item.code);

          // 创建临时元素来测量文本宽度
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');

          // 根据当前语言设置字体大小
          const currentLang = localStorage.getItem('lang') || 'zh_CN';
          const fontSize = currentLang === 'zh_CN' ? '14px' : '12px';
          context.font = `${fontSize} "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif`;

          const textWidth = context.measureText(text).width;

          maxWidth = Math.max(maxWidth, textWidth);

          // 递归计算子菜单
          if (item.children && item.children.length > 0) {
            const childMaxWidth = this.calculateMenuWidth(item.children);
            maxWidth = Math.max(maxWidth, childMaxWidth);
          }
        }
      });

      return maxWidth;
    },

    getParameter(query, param) {
      var iLen = param.length;
      var iStart = query.indexOf(param);
      if (iStart == -1) return "";
      iStart += iLen + 1;
      var iEnd = query.indexOf("&", iStart);
      if (iEnd == -1) return decodeURIComponent(query.substring(iStart));
      return decodeURIComponent(query.substring(iStart, iEnd));
    },
    makeUrl(str) {
      let url = this.getParameter(str, 'url')
      url = decodeURIComponent(url)
      if (url.indexOf('?') == -1) {
        url += '?_='
      }
      url = url + '&ssoToken=' + localStorage.getItem('ssoToken');


      return url
    },


    toggleSidebar(isOpen) {
      if (isOpen != null) {
        this.store.state.is_sidebar_open = isOpen;
      } else {
        this.store.state.is_sidebar_open = !this.store.state.is_sidebar_open;
      }
      this.resizeWindow();
    },
    toggleTabbar(isOpen) {
      console.log(isOpen);
      //只有不同才resizeWindows，不然会多次触发resizeWindow，让那些不处于激活的tab被resize，会有很多dom获取不到
      if (isOpen != null && isOpen != this.store.state.is_monitor_full) {
        this.store.state.is_monitor_full = isOpen;
        this.resizeWindow();
      }
    },
    resizeWindow() {
      this.$nextTick(() => {
        let isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
        this.store.commit("SET_WINDOW_INNER_HEIGHT", window.innerHeight);
        this.side_height = window.innerHeight + "px";
        this.content_width = window.innerWidth - (this.store.state.is_sidebar_open ? this.dynamicMenuWidth : 64) + "px";
        this.height = window.innerHeight - this.$refs.header.offsetHeight - (this.$refs.router_tabs ? this.$refs.router_tabs.offsetHeight : 0) + "px";
        this.store.commit("SET_ROUTER_VIEW_WIDTH", window.innerWidth - this.$refs.sidebar.offsetWidth);
        this.store.commit("SET_ROUTER_VIEW_HEIGHT", window.innerHeight - this.$refs.header.offsetHeight - (this.$refs.router_tabs ? this.$refs.router_tabs.offsetHeight : 0));
        // alert(this.$refs.router_tabs.offsetHeight)
        this.utils.event_hub.$emit("RESIZE");
      });
    },

    clickTab(tab) {
      if (this.$route.path == tab.name) {
        return;
      }


      this.$router.push(tab.name);

      //先push，假设aps没有拦截，那么就不需要回设，假设拦截了，nextTick检测到也是还处于aps
      this.$nextTick(() => {
        if (this.$route.path == "/web/scheduling/aps") {
          this.current_path = "";
          this.$nextTick(() => {
            this.current_path = "/web/scheduling/aps";
          });
        }
      });
    },
    removeTab(tab) {
      //处于aps关闭aps才会触发
      if (this.$route.path == "/web/scheduling/aps" && tab == "/web/scheduling/aps") {
        this.utils.event_hub.$emit("APS_BEFORE_CLOSE", tab);
        return;
      }

      this.store.commit("DELETE_ROUTER_TAB", tab);
    },
  },
};
</script>
